export enum RepaymentType {
    CC_PayOff,
    CC_PayFixed,
    CC_PayMin
}
